<template>
  <div
    class="manage-shell app-shell"
    :style="{
      marginTop: headerHeight + 'px',
      minHeight: 'calc(100vh - ' + headerHeight + 'px)'
    }"
  >
    <div
      class="manage-sidebar app-sidebar"
      :style="{ top: headerHeight + 'px' }"
    >
      <el-menu
        class="manage-menu"
        :default-active="type"
        :default-openeds="['devices']"
        background-color="transparent"
        @select="selectType"
      >
        <el-menu-item v-if="p('Manage.Users.View')" index="users">
          <i class="el-icon-user"></i>
          <span slot="title">{{ $t('text.users') }}</span>
        </el-menu-item>
        <el-menu-item v-if="p('Manage.Roles.View')" index="roles">
          <i class="el-icon-s-custom"></i>
          <span slot="title">{{ $t('text.roles') }}</span>
        </el-menu-item>
        <el-menu-item v-if="p('Manage.Distributors.View')" index="distributors">
          <i class="el-icon-office-building"></i>
          <span slot="title">Distributors</span>
        </el-menu-item>
        <el-submenu index="devices">
          <template slot="title">
            <i class="el-icon-cpu"></i>
            <span>Devices</span>
          </template>
          <el-menu-item index="devices-pods">Pods</el-menu-item>
          <el-menu-item index="devices-nodes">Nodes</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div class="manage-main app-main">
      <div class="manage-page">
        <AppBreadcrumb
          root="Manage"
          :current="typeTitle"
          @root-click="selectType('users')"
        >
          <el-button
            v-if="pageAction"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="pageAction.onClick"
            >{{ pageAction.label }}</el-button
          >
        </AppBreadcrumb>

        <UserList v-if="type === 'users'" />
        <RoleList v-if="type === 'roles'" />
        <Distributors v-if="type === 'distributors'" />
        <Pods v-if="type === 'devices-pods'" />
        <Nodes v-if="type === 'devices-nodes'" />
      </div>
    </div>
  </div>
</template>

<script>
import UserList from '@/components/manage/UserList'
import RoleList from '@/components/manage/RoleList'
import Distributors from '@/components/manage/Distributors'
import Pods from '@/components/manage/devices/Pods'
import Nodes from '@/components/manage/devices/Nodes'
import headerHeight from '@/mixins/headerHeight'
import AppBreadcrumb from '@/components/AppBreadcrumb'

const TYPE_TITLES = {
  users: 'Users',
  roles: 'Roles',
  distributors: 'Distributors',
  'devices-pods': 'Pods',
  'devices-nodes': 'Nodes'
}

export default {
  mixins: [headerHeight],
  data() {
    return {
      type: 'users',
      pageAction: null
    }
  },
  components: {
    UserList,
    RoleList,
    Distributors,
    Pods,
    Nodes,
    AppBreadcrumb
  },
  computed: {
    typeTitle() {
      return TYPE_TITLES[this.type] || ''
    }
  },
  mounted() {
    if (this.$permission('Manage.Users.View')) {
      this.type = 'users'
    } else if (this.$permission('Manage.Roles.View')) {
      this.type = 'roles'
    } else {
      this.type = 'distributors'
    }
  },
  methods: {
    selectType(type) {
      this.type = type
      this.pageAction = null
    },
    setPageAction(action) {
      this.pageAction = action
    },
    clearPageAction() {
      this.pageAction = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.manage-page {
  flex: 1;
  padding: 20px 24px;

  // The child list components (UserList/RoleList/Distributors) each have
  // their own root `.manage-content` div, which is also a *global* class
  // (src/assets/css/manage.scss) carrying a `margin-top: 100px` calibrated
  // for the old fixed header + horizontal tab bar. That offset is now
  // handled by this shell instead, so it's reset to 0 here. `.page-title`
  // (the redundant "Users"/"Roles"/"Distributors" heading, now replaced by
  // the breadcrumb above) is hidden the same way — both live in components
  // this pass doesn't otherwise touch, so overriding via CSS avoids editing
  // three separate files for one heading each.
  /deep/ .manage-content {
    margin-top: 0 !important;
  }

  /deep/ .page-title {
    display: none;
  }

  // Table look is unified globally in global.scss (.el-table), no
  // per-module override needed here.
}
</style>
